
import React from 'react';
import { Button } from '@/components/ui/button';
import { Edit, Trash2, FileText } from 'lucide-react';
import { getBrowserInfo } from '@/utils/printing/printingBridge';
import { isDesktopEnvironment } from '@/utils/desktop/desktopEnvironment';
import { toast } from 'sonner';

interface ExamActionsProps {
  examId: string;
  studentId: string | number;
  onDelete: () => void;
  onPrintCertificate: () => void;
}

const ExamActions = ({ examId, studentId, onDelete, onPrintCertificate }: ExamActionsProps) => {
  const handleEdit = () => {
    // Navigate to the edit page
    window.location.href = `/students/${studentId}/exams/${examId}`;
  };

  const handlePrintCertificate = () => {
    try {
      const browserInfo = getBrowserInfo();
      console.log('Print environment:', browserInfo);
      
      // Special handling for desktop and Nativefier apps
      if (isDesktopEnvironment() || browserInfo.isNativefier) {
        toast.info('Opening print preview in external browser...', {
          duration: 3000
        });
        
        // Add a small delay for desktop environments
        setTimeout(() => {
          onPrintCertificate();
        }, 300);
      } else {
        // Regular web environment
        onPrintCertificate();
      }
    } catch (error) {
      console.error('Error printing certificate:', error);
      toast.error('Failed to print certificate');
    }
  };

  return (
    <div className="flex justify-end space-x-2">
      <Button
        variant="outline"
        size="icon"
        className="text-blue-600 hover:text-blue-700"
        onClick={handlePrintCertificate}
        title="Print Certificate"
      >
        <FileText className="h-4 w-4" />
        <span className="sr-only">Print Certificate</span>
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={handleEdit}
        title="Edit Exam"
      >
        <Edit className="h-4 w-4" />
        <span className="sr-only">Edit</span>
      </Button>
      <Button
        variant="outline"
        size="icon"
        className="text-red-500 hover:text-red-600"
        onClick={onDelete}
        title="Delete Exam"
      >
        <Trash2 className="h-4 w-4" />
        <span className="sr-only">Delete</span>
      </Button>
    </div>
  );
};

export default ExamActions;
